import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  style: {"width":"3rem","height":"3rem"},
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Cargando...")
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_5 = {
  key: 2,
  class: "alert alert-secondary",
  role: "alert"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Muy pronto, verás publicados dibujos en esta sección.", -1)
const _hoisted_7 = [
  _hoisted_6
]

import { ref, onMounted, Ref } from 'vue'
import Resource from '@/data/tools/Resource'
import { Draw } from '@/data/models/Draw'
import DrawDao from '@/data/dao/DrawDao'
import DrawComponent from '@/views/drawings/components/DrawComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DrawingsPage',
  setup(__props) {

const d = new DrawDao()

const drawings: Ref<Array<Draw>> = ref([])

const loading = ref(false)
const error = ref(false)

async function getDraws(){
  await d.getDraws((resource: Resource) => {
    switch (resource.status) {
      case Resource.LOADING:
        loading.value = true
        break
      case Resource.ERROR:
        error.value = true
        loading.value = false
        break
      case Resource.SUCCESS:
        drawings.value = [...drawings.value, ...resource.data]
        loading.value = false
        break
      default:
        break
    }
  })
}

async function getNextDraw(){
  await d.getNextDraws((resource: Resource) => {
    switch (resource.status) {
      case Resource.LOADING:
        loading.value = true
        break
      case Resource.ERROR:
        error.value = true
        loading.value = false
        break
      case Resource.SUCCESS:
        drawings.value = [...drawings.value, ...resource.data]
        loading.value = false
        break
      default:
        break
    }
  })
}

onMounted(async() => {
  await getDraws()
    // window.addEventListener('scroll', async () => {
    //   const endPage = document.documentElement.scrollHeight - window.innerHeight
    //   if(window.scrollY === endPage){
    //     await getNextDraw()
    //   }
    // })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Error obteniendo los dibujos! "))
      : _createCommentVNode("", true),
    (drawings.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : _createCommentVNode("", true),
    _createVNode(DrawComponent, {
      drawings: drawings.value,
      columnWidth: 270,
      gap: 16
    }, null, 8, ["drawings"])
  ], 64))
}
}

})